if (!customElements.get('glh-catalog')) {
  customElements.define('glh-catalog', class extends HTMLElement {
    connectedCallback() {
      this.frame = requestAnimationFrame(() => this.setup());
    }
    disconnectedCallback() {
      cancelAnimationFrame(this.frame);
      this.events?.abort();
    }
    setup() {
      this.events?.abort();
      this.events = new AbortController();
      const options = { signal: this.events.signal };
      this.grid = this.querySelector('[data-grid]');
      this.cards = [...this.querySelectorAll('[data-card]')];
      this.buttons = [...this.querySelectorAll('[data-filter]')];
      this.counter = this.querySelector('[data-count]');
      this.sorter = this.querySelector('[data-sort]');
      this.empty = this.querySelector('[data-empty]');
      if (!this.grid || !this.counter) return;
      this.activeFilter = 'all';
      this.buttons.forEach(button => {
        button.hidden = button.dataset.filter !== 'all' && !this.cards.some(card => card.dataset.category === button.dataset.filter);
        button.addEventListener('click', () => {
          this.activeFilter = button.dataset.filter;
          this.update();
        }, options);
      });
      this.sorter?.addEventListener('change', () => this.update(), options);
      this.querySelectorAll('[data-show-all]').forEach(link => link.addEventListener('click', () => {
        this.activeFilter = 'all';
        this.update();
      }, options));
      this.querySelectorAll('[data-controls]').forEach(control => { control.hidden = false; });
      this.update();
    }
    update() {
      const sorting = this.sorter?.value || 'recommended';
      const cards = [...this.cards].sort((left, right) => {
        const rank = Number(left.dataset.rank) - Number(right.dataset.rank);
        const price = Number(left.dataset.price) - Number(right.dataset.price);
        if (sorting === 'price-ascending') return price || rank;
        if (sorting === 'price-descending') return -price || rank;
        return rank;
      });
      let count = 0;
      cards.forEach(card => {
        card.hidden = this.activeFilter !== 'all' && card.dataset.category !== this.activeFilter;
        if (!card.hidden) count += 1;
        this.grid.append(card);
      });
      this.buttons.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.filter === this.activeFilter)));
      this.counter.textContent = count === 1 ? this.counter.dataset.one : this.counter.dataset.many.replace('999', String(count));
      this.empty.hidden = count !== 0;
    }
  });
}
